import React from "react";
import {
  Grid,
  CardMedia,
  makeStyles,
  createStyles,
  Theme,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    totalSector: {
      marginTop: "4rem !important",
      display: "flex",
      fontFamily: "Noto Sans KR",
      [theme.breakpoints.down("xs")]: {
        display: "block",
        marginTop: "1rem",
      },
    },
    leftDivSector: {
      paddingRight: "6rem",
      [theme.breakpoints.down("xs")]: {
        paddingRight: 0,
      },
    },
    imgSec: {
      position: "relative",
      width: "100%",
      paddingTop: "56.25%",
    },

    aspectRatioBox: {
      height: 0,

      //   paddingTop: "calc(591.44px / 1127.34px * 100%)",
      paddingTop: "56.25%",
      overflow: "hidden",
      backgroundColor: "#FFC007",
      // backgroundColor: "#F6D300",
      // backgroundColor: "#FEE715",
      position: "relative",
    },

    aspectRatioBoxInside: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
    },
    fireboxCentering: {
      // width: "100%",
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },

    viewPortSizing: {
      // fontSize: "5vw",
      zIndex: 0,
    },
    tuneWinnerCategory: {
      fontSize: 16,
      fontWeight: 900,
      color: "black",
      fontFamily: "Noto Sans KR",
    },
    tuneWinnerTitle: {
      marginTop: 16,
      fontSize: 48,
      fontWeight: 500,
      color: "black",
      fontFamily: "Noto Sans KR",
      letterSpacing: -2,
      marginLeft: -5,
    },
    winnerDiv: {
      // paddingTop: "4rem"
    },
    winnerCategory: {
      fontSize: 16,
      fontWeight: 900,
      paddingRight: 32,
      //   color: "#7a5f50",
      color: "black",
      fontFamily: "Noto Sans KR",
      paddingBottom: 8,
    },
    winnerName: {
      fontSize: 20,
      fontWeight: 400,
      color: "black",
      fontFamily: "Noto Sans KR",
      lineHeight: 1.5,
    },
    winnerTopDiv: {
      //   display: "flex",
      paddingBottom: 32,
    },
    storyText: {
      color: "black",
      paddingTop: "3rem",
      lineHeight: 1.5,
    },
    likeImg: {
      // backgroundColor: "#F6D300",
    },
    likeImgTitle: {
      // color: "#1dacd6",
      color: "#0f4c81",
      // color: "#418FDE",
      textAlign: "center",
      fontSize: 48,
      // fontWeight: 900,
      // fontFamily: "Gothic A1",
      fontFamily: `"62570체"`,
      paddingBottom: 56,
    },
    likeImgSubtilte: {
      fontFamily: "Noto Serif KR",
      fontWeight: 900,
      fontSize: 48,
      color: "#fff",
      textAlign: "center",
    },
  })
);

interface AspectDivProps {
  children: React.ReactNode;
}
function AspectDiv(props: AspectDivProps) {
  const classes = useStyles();

  return (
    <div className={classes.aspectRatioBox}>
      <div className={classes.aspectRatioBoxInside}>
        <div className={classes.fireboxCentering}>
          <div className={classes.viewPortSizing}>{props.children}</div>
        </div>
      </div>
    </div>
  );
}

interface LeftImgTemplateProps {
  image: React.ReactNode;
  describe: React.ReactNode;
}

function AboutLeftTemplate({ describe, image }: LeftImgTemplateProps) {
  const classes = useStyles();

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("xs"));
  return (
    <Grid xs={12} item className={classes.totalSector}>
      <Grid xs={!matches ? 12 : 12} item className={classes.leftDivSector}>
        <AspectDiv>{image}</AspectDiv>
      </Grid>
      <Grid xs={!matches ? 12 : 12} item>
        <div className={classes.winnerDiv}>
          <div className={classes.winnerTopDiv}>
            <Grid xs={12} item>
              <div className={classes.winnerName}>{describe}</div>
            </Grid>
          </div>
        </div>
      </Grid>
    </Grid>
  );
}

export default AboutLeftTemplate;
